<script lang="ts">
  import type { VariantProps } from "class-variance-authority"
  import type { Snippet } from "svelte"
  import { bodyVariant, cn } from ".."

  type Props = {
    variant?: VariantProps<typeof bodyVariant>["variant"]
    class?: string
    children?: Snippet
    [key: string]: unknown
  }

  let {
    variant = "default",
    class: cssClass = "",
    children,
    ...restProps
  }: Props = $props()
</script>

<div
  role="rowgroup"
  class={cn(bodyVariant({ variant }), cssClass)}
  {...restProps}
>
  {@render children?.()}
</div>
